import { showNotification } from '@mantine/notifications';
import { AxiosInstance } from 'axios';
import { RetrieveMerchantResponse } from '../type/admin.types';
import { ErrorResponse } from '../type/error-response.types';
import { X } from 'tabler-icons-react';

export const parseLink = (link: string) => {
  return link.trim().startsWith('http://') || link.trim().startsWith('https://')
    ? link.trim()
    : `//${link.trim()}`;
};
